import { settings, utils } from '@pixi/core';
export { settings } from '@pixi/core';
import { Mesh } from '@pixi/mesh';

Object.defineProperties(settings, {
  MESH_CANVAS_PADDING: {
    get() {
      return Mesh.defaultCanvasPadding;
    },
    set(value) {
      utils.deprecation("7.1.0", "settings.MESH_CANVAS_PADDING is deprecated, use Mesh.defaultCanvasPadding");
      Mesh.defaultCanvasPadding = value;
    }
  }
});
//# sourceMappingURL=settings.mjs.map
